import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { AppMarkdownParser } from "../../../../../../shared/components/AppMarkdownParser";
import { AppLoading } from "../../../../../../shared/components/AppLoading";
import { AppButton } from "../../../../../../shared/components/AppButton";
import { SparksIcon } from "../../../../../../shared/icons/SparksIcon";
import styles from "./styles.module.css";
import { hiddenSecurityPart } from "../../../../../../shared/utils/hiddenSecurityPart";

interface Props {
  initialPrompt: string;
  result: string;
  isLoading: boolean;
  generatePrompt: () => void;
}

export const GeneratePromptBody = ({
  initialPrompt,
  result,
  isLoading,
  generatePrompt,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <AppMarkdownParser
        content={hiddenSecurityPart(initialPrompt)}
        className={styles["markdown-wrapper"]}
      />
      <div className={styles["dynamic-block"]}>
        {isLoading ? (
          <AppLoading small />
        ) : (
          <AppButton
            buttonType={"text"}
            icon={<SparksIcon />}
            onClick={generatePrompt}
            className={styles["generate-button"]}
          >
            {t("assistants.generate_prompt_improve_button")}
          </AppButton>
        )}
      </div>
      <AppMarkdownParser
        content={
          result === ""
            ? `${t("assistants.generate_prompt_result_placeholder")}`
            : result
        }
        className={classNames(styles["markdown-wrapper"], {
          [styles["placeholder"]]: result === "",
        })}
      />
    </div>
  );
};
